module.exports = __webpack_public_path__ + "843d434e9ca5fc75d6466ac06aaa7691.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-5.png
// module id = 2334
// module chunks = 0